import { useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { forumAttachmentPath } from './forumAttachmentPath';

export default function ForumAttachment({ value, name, type, thumbnail = false }) {
 const [result, setResult] = useState(null);
 const [attempt, setAttempt] = useState(0);
 const path = forumAttachmentPath(value, process.env.REACT_APP_SUPABASE_URL);
 useEffect(() => {
  let cancelled = false, objectUrl;
  setResult(null);
  if (!path) { setResult({error:true}); return; }
  async function load() {
   try {
    const { data, error } = await supabase.storage.from('forum-attachments').download(path, {}, { cache: 'no-store' });
    if (error || !data?.size) throw new Error('Unavailable');
    if (cancelled) return;
    objectUrl = URL.createObjectURL(data);
    setResult({url:objectUrl});
   } catch { if (!cancelled) setResult({error:true}); }
  }
  load();
  return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
 }, [path, attempt]);
 if (!result) return <span role="status">Loading attachment…</span>;
 if (result.error) return thumbnail ? <span>Attachment unavailable</span> : <div role="alert">Attachment unavailable. Access may have changed. <button type="button" onClick={() => setAttempt(n => n + 1)}>Retry attachment</button></div>;
 if (type?.startsWith('image/')) {
  const image = <img src={result.url} alt={name || 'Forum attachment'} className={thumbnail ? 'forum-post-thumb' : 'thread-post-attachment-img'} />;
  return thumbnail ? image : <a href={result.url} target="_blank" rel="noopener noreferrer">{image}</a>;
 }
 return <a href={result.url} target="_blank" rel="noopener noreferrer" className="forum-post-file-chip thread-attachment-link">Open {name || 'attachment'}</a>;
}
